const carousel = document.querySelector('#carousel .carousel-inner')

/**
 * Create carousel dots and set the active dot
 */
const createCarouselDots = () => {
	if (carousel) {
		// Observer for setting correct dot active
		let observer = new MutationObserver((mutationList) => {
			let currentItem
			for (const mutation of mutationList) {
				if (mutation.target.className === 'item active') currentItem = mutation.target
			}
			if (typeof currentItem == 'undefined') return
			const actualIndex = [...document.querySelectorAll('.carousel-inner .item')].indexOf(currentItem),
				dotsList = document.querySelectorAll('.carousel-dots li')
			for (const dot of dotsList) {
				dot.classList.remove('dot-active')
			}
			dotsList[actualIndex].classList.add('dot-active')
		})
		// Create dots
		let dotsCounter = 0,
			dotsList = document.createElement('ul')
		dotsList.classList.add('carousel-dots')
		const carouselItems = carousel.querySelectorAll('.item')
		if (carouselItems.length <= 1) return
		for (const [index, item] of carouselItems.entries()) {
			dotsCounter += 1
			let dotEl = document.createElement('li')
			dotsList.appendChild(dotEl)
			if (index === 0) dotEl.classList.add('dot-active')
			dotEl.addEventListener('click', (e) => {
				e.preventDefault()
				document.querySelector('.carousel-inner .item.active').classList.remove('active')
				let targetItem = document.querySelectorAll('.carousel-inner .item')[index]
				const targetItemImg = targetItem.querySelector('img')
				if (!targetItemImg.src) targetItemImg.src = targetItemImg.getAttribute('data-src')
				targetItem.classList.add('active')
			})
			observer.observe(item, {
				attributes: true,
				attributeFilter: ['class'],
			})
		}
		const controlsWrapper = document.createElement('div')
		controlsWrapper.classList.add('carousel-controls-wrapper')
		const leftControl = document.querySelector('#carousel .carousel-control.left'),
			rightControl = document.querySelector('#carousel .carousel-control.right')
		if (leftControl) controlsWrapper.appendChild(leftControl)
		controlsWrapper.appendChild(dotsList)
		if (rightControl) controlsWrapper.appendChild(rightControl)
		carousel.appendChild(controlsWrapper)
	}
}

/**
 * Calculate the minimum height of the carousel texts for mobile devices and set it as a CSS variable `--min-texts-height`
 */
const setCarouselMinHeightMobile = () => {
	if (window.innerWidth <= 767 && carousel) {
		let carouselTextsMinHeight = 0
		const carouselTexts = carousel.querySelectorAll('.extended-banner-texts')
		const carouselHelper = document.createElement('div')
		carouselHelper.id = 'carousel'
		document.body.appendChild(carouselHelper)
		carouselTexts.forEach((texts) => {
			const clone = texts.cloneNode(true)
			carouselHelper.appendChild(clone)
			if (clone.offsetHeight > carouselTextsMinHeight) {
				carouselTextsMinHeight = clone.offsetHeight
			}
		})
		carouselHelper.remove()
		carousel.parentElement.style.setProperty(`--min-texts-height`, `${carouselTextsMinHeight}px`)
	}
}

export { createCarouselDots, setCarouselMinHeightMobile }
